import { Modal, Input } from '@salecycle/ui-component-library';
import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useCampaignEditorContext } from '../../contexts/CampaignEditorContext';
import { useSaveWorkflow } from '../../hooks/useSaveWorkflow';
import { useCampaignSettings } from '../../tabs/CampaignWorkflowTab/state/CampaignSettings/hooks/useCampaignSettings';

interface Props {
  open: boolean;
  onClose: () => void;
}

export function AddCampaignNameModal({ open, onClose }: Props) {
  const { dispatch } = useCampaignEditorContext();

  const { name } = useCampaignSettings();
  const [campaignName, setCampaignName] = useState(null);
  const [campaignIsReadyToSave, setCampaignIsReadyToSave] = useState(false);

  const { t } = useTranslation('campaigns');

  const saveWorkflow = useSaveWorkflow();

  const onOkButtonClicked = useCallback(() => {
    dispatch({
      type: 'SET_CAMPAIGN_NAME',
      payload: { name: campaignName },
    });
    setCampaignIsReadyToSave(true);
    onClose();
  }, [campaignName, dispatch, onClose, setCampaignIsReadyToSave]);

  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    if (campaignIsReadyToSave) {
      saveWorkflow();
      setCampaignIsReadyToSave(false);
    }
  }, [name]);

  const onCloseButtonClicked = useCallback(() => {
    setCampaignName(null);
    onClose();
  }, [onClose]);

  const onChange = useCallback(value => {
    setCampaignName(value);
  }, []);

  return (
    <>
      <Modal
        minWidth={700}
        heading={t('onsite.editor.workflow.addCampaignNameModal.heading')}
        isOpen={open}
        variation="clean"
        onCloseButtonClicked={onCloseButtonClicked}
        cancelButtonAriaLabel={t('onsite.editor.workflow.addCampaignNameModal.cancelButtonAriaLabel')}
        onOkButtonClicked={onOkButtonClicked}
        okButtonLabel={t('onsite.editor.workflow.addCampaignNameModal.okButtonLabel')}
        okButtonAriaLabel={t('onsite.editor.workflow.addCampaignNameModal.okButtonLabel')}
        okButtonDisabled={campaignName?.length < 5 || campaignName?.length > 100 || !campaignName}
      >
        <Input
          type="text"
          placeholder={t('onsite.editor.workflow.addCampaignNameModal.placeholder')}
          value={campaignName}
          onChange={onChange}
          ariaLabel={t('onsite.editor.workflow.addCampaignNameModal.inputAriaLabel')}
          label={t('onsite.editor.workflow.addCampaignNameModal.inputLabel')}
          hasCharCount={true}
          charLength={campaignName?.length ?? 0}
          isBottomCharCount={true}
          maxLength={100}
          validationMessage={
            (campaignName?.length < 5 || campaignName?.length > 100 || !campaignName) &&
            t('onsite.editor.workflow.addCampaignNameModal.validationMessage')
          }
        />
      </Modal>
    </>
  );
}
